@if (!isAdvicePage) {
  <nes-heading
    color="text-inverse-subdued"
    class="nes-mb-5 nes-px-5 md:nes-px-0"
    tag="h2"
    [size]="{ xs: '400', md: '400' }"
  >
    {{ "RECEIPT.TITLE" | translate }}
  </nes-heading>

  <div *ngFor="let step of steps">
    @let stepAnswers = answers[step.id] ?? {};
    @let entries = stepAnswers | keyvalue;

    <nes-divider
      type="secondary"
      class="nes-my-3 nes-bg-primary-pale"
      [ngClass]="step.id === 'step2' ? 'nes-block' : 'nes-hidden'"
    ></nes-divider>

    <div class="nes-flex nes-justify-between">
      <div class="nes-mb-5">
        <div class="nes-flex nes-gap-10 nes-justify-between">
          @if (
            !(step.id === "step1" && stepAnswers["organisation_name"] === "")
          ) {
            <nes-heading
              class="nes-mb-5"
              [weight]="step.id === 'step1' ? 'bold' : 'normal'"
              [size]="
                step.id === 'step1'
                  ? { xs: '600', md: '1000' }
                  : { xs: '400', md: '400' }
              "
              color="text-inverse-subdued"
            >
              @if (step.id === "step1") {
                {{ stepAnswers["organisation_name"] }}
              } @else {
                {{ step.titleForReceipt | translate }}
              }
            </nes-heading>
          }
        </div>

        @if (step.id === "step1") {
          <div class="nes-flex nes-gap-3">
            @for (entry of entries; track entry.key) {
              @let labels = getReceiptLabel(step.id, entry.key, entry.value);

              @for (label of labels; track label) {
                @if (label && label === stepAnswers["number_of_employees"]) {
                  <nes-sticker rounded="false" type="highlight">
                    {{ label | translate }}

                    @if (entry.key === "number_of_employees") {
                      @if (label === "1") {
                        {{ "RECEIPT.SINGLE_EMPLOYEE" | translate }}
                      } @else {
                        {{ "RECEIPT.MULTIPLE_EMPLOYEES" | translate }}
                      }
                    }
                  </nes-sticker>
                }
              }
            }
          </div>
        } @else if (step.id === "step2") {
          @if (stepAnswers && (stepAnswers | keyvalue).length > 0) {
            <nes-text weight="bold" color="text-inverse-subdued">
              @for (entry of stepAnswers | keyvalue; track entry.key) {
                <nes-text weight="bold" color="text-inverse-subdued">
                  {{ getReceiptText(step.id, entry.key, entry.value) }}
                </nes-text>
              }
            </nes-text>
          } @else {
            <nes-text weight="bold" color="text-inverse-subdued">
              {{ "GENERAL.NO_SELECTION" | translate }}
            </nes-text>
          }
        } @else {
          <ng-container *ngFor="let entry of stepAnswers | keyvalue">
            @let labels = getReceiptLabel(step.id, entry.key, entry.value);

            <ng-container *ngFor="let label of labels">
              <nes-text weight="bold" color="text-inverse-subdued">
                {{ label | translate }}
              </nes-text>
            </ng-container>
          </ng-container>
        }
      </div>

      <nes-icon
        name="edit"
        color="primary-pale"
        (click)="goToStep(step.id)"
      ></nes-icon>
    </div>

    <nes-divider
      type="secondary"
      class="nes-my-3 nes-bg-primary-pale"
      [ngClass]="step.id === 'step1' ? 'nes-hidden' : 'nes-block'"
    ></nes-divider>
  </div>
} @else {
  <div *ngFor="let step of filteredSteps">
    @let stepAnswers = answers[step.id];
    @let pointer = getAdvicePointer(step);

    <nes-divider
      type="secondary"
      class="nes-my-3 nes-bg-primary-pale"
      [ngClass]="step.id === 'step2' ? 'nes-block' : 'nes-hidden'"
    ></nes-divider>

    <div class="nes-mb-5 nes-flex nes-justify-between nes-items-center">
      <div class="container">
        <div class="nes-flex nes-gap-10 nes-justify-between">
          <nes-heading
            class="nes-mb-3"
            [weight]="step.id === 'step1' ? 'bold' : 'normal'"
            [size]="
              step.id === 'step1'
                ? { xs: '600', md: '1000' }
                : { xs: '400', md: '400' }
            "
            color="text-inverse-subdued"
          >
            @if (step.id === "step1") {
              {{ stepAnswers["organisatieNaam"] }}
            } @else {
              {{ step.title | translate }}
            }
          </nes-heading>
        </div>

        @if (step.id === "step2") {
          @if (stepAnswers && (stepAnswers | keyvalue).length > 0) {
            <nes-text weight="bold" color="text-inverse-subdued">
              @for (entry of stepAnswers | keyvalue; track entry.key) {
                @let labels = getReceiptLabel(step.id, entry.key, entry.value);

                @for (
                  label of labels;
                  track label;
                  let i = $index;
                  let last = $last
                ) {
                  {{ label | translate }}

                  @if (!last) {
                    @if (labels.length > 1 && i === labels.length - 2) {
                      {{ "RECEIPT.CONJUNCTION" | translate }}
                    } @else {
                      ,
                    }
                  }
                }
              }
            </nes-text>
          } @else {
            <nes-text weight="bold" color="text-inverse-subdued">
              {{ "GENERAL.NO_SELECTION" | translate }}
            </nes-text>
          }
        } @else {
          <ng-container *ngFor="let entry of stepAnswers | keyvalue">
            @let labels = getReceiptLabel(step.id, entry.key, entry.value);

            <ng-container *ngFor="let label of labels">
              <nes-text weight="bold" color="text-inverse-subdued">
                {{ label | translate }}
              </nes-text>
            </ng-container>
          </ng-container>
        }
      </div>

      <div class="nes-flex nes-gap-10 nes-items-center">
        @if (pointer === "Start") {
          <nes-sticker type="highlight" rounded="false">
            <nes-text class="nes-w-7 nes-flex nes-justify-center">
              {{ pointer }}
            </nes-text>
          </nes-sticker>
        }

        @if (pointer === "Plus") {
          <nes-sticker filled type="offer" rounded="false">
            <nes-text
              color="text-inverse-subdued"
              class="nes-w-7 nes-flex nes-justify-center"
            >
              {{ pointer }}
            </nes-text>
          </nes-sticker>
        }

        @if (pointer === "Pro") {
          <nes-sticker filled type="highlight" rounded="false">
            <nes-text
              color="text-inverse-subdued"
              class="nes-w-7 nes-flex nes-justify-center"
            >
              {{ pointer }}
            </nes-text>
          </nes-sticker>
        }

        <nes-icon
          name="edit"
          color="primary-pale"
          (click)="goToStep(step.id)"
        ></nes-icon>
      </div>
    </div>

    <nes-divider
      type="secondary"
      class="nes-my-3 nes-bg-primary-pale"
      [ngClass]="step.id === 'step1' ? 'nes-hidden' : 'nes-block'"
    ></nes-divider>
  </div>
}
